module.exports = __webpack_public_path__ + "static/media/git_search.7b615d46.png";